import React from "react";
import LegalDocument from "../components/site/LegalDocument";
import LEGAL_DOCUMENTS from "../content/legal";

const Privacy = () => (
  <LegalDocument blocks={LEGAL_DOCUMENTS.privacy} pageTitle="Privacy Policy · Mise" testId="page-privacy" />
);

export default Privacy;
